<template>
<!-- MAIN CONTAINER -->
<div id="mainContainer">
<h1>SCREENSHOTS</h1>
    <!-- GALLERY -->
    <div id="gallery">
                    <span class="imgContainer">
                        <img src="/static/img/screenshots/1.png">
                          <span class="imgOverlay" title="Screenshot 1" label="COMMANDOTHUG"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/screenshots/2.png">
                        <span class="imgOverlay" title="Screenshot 2" label="COMMANDOTHUG"></span>
                    </span>
                    
                    <span class="imgContainer">
                        <img src="/static/img/screenshots/3.png">
                          <span class="imgOverlay" title="Screenshot 3" label="COMMANDOTHUG"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/screenshots/4.png">
                          <span class="imgOverlay" title="Screenshot 4" label="COMMANDOTHUG"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/screenshots/5.png">
                          <span class="imgOverlay" title="Screenshot 5" label="COMMANDOTHUG"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/screenshots/6.png">
                          <span class="imgOverlay" title="Screenshot 6" label="COMMANDOTHUG"></span>
                    </span>

          </div>
              <!-- END OF GALLERY -->
</div>
<!-- END OF MAIN CONTAINER -->
</template>

<script>

export default {
   mounted(){
    this.initGallery();

   },
   beforeDestroy() {
    this.removeGallery();
   }
}

</script>



// WEBPACK FOOTER //
// Screenshots.vue?150bb9e2